import { Box } from '@mui/system';
import useStyles from './styles';
import Typography from '@mui/material/Typography';
import InfoButton from '../InfoButton';

const PageHeading = ({
	headingName,
	headingPath = [],
	description = '',
	showInfoButton = false,
	infoMessage = '',
	infoButtonProps = {}
}) => {
	const classes = useStyles();

	return (
		<>
			<Box className={classes.headingContainer}>
				<Typography variant="inherit" fontWeight="bold" className={classes.pagePath}>
					{headingPath.join(' > ')}
				</Typography>
				<Typography variant="h4" fontWeight="bold" className={classes.headingName}>
					{headingName}
					{showInfoButton && headingName?.trim() && (
						<InfoButton message={infoMessage} {...infoButtonProps} />
					)}
				</Typography>
				{description && (
					<Box className={classes.description}>
						<Typography variant="subtitle1" fontWeight="bold">
							{description}
						</Typography>
					</Box>
				)}
			</Box>
		</>
	);
};
export default PageHeading;
